import axios from "axios";

export const apiBaseUrl = import.meta.env.CORE_PLATFORM_SERVICE_URL;

export const httpClient = axios.create({
  baseURL: apiBaseUrl,
});
